// "Pay in instalments" (card 15862648) — client mirror of the backend rules
// (helpers/oireachtasInstalments.js). The server re-validates everything; this
// only keeps the Pay button honest before the round trip.
import moment from "moment";
import { formatDate } from "../../helper/formatDate";

export const MIN_PAYMENT_CENTS = 10000;

/** "$1,234.56" -> 123456 cents; null when it isn't a money amount. */
export function parseMoneyCents(text) {
  const clean = String(text == null ? "" : text).replace(/[$,\s]/g, "");
  if (!/^\d+(\.\d{0,2})?$/.test(clean)) return null;
  return Math.round(parseFloat(clean) * 100);
}

/** Error text for one payment against what is owed, or null when fine. */
export function paymentAmountError(amountCents, balanceCents, minCents = MIN_PAYMENT_CENTS) {
  if (amountCents == null || amountCents <= 0) return "Enter the amount to pay now.";
  if (amountCents > balanceCents) return "That is more than the amount owing.";
  const min = Math.min(minCents, balanceCents);
  if (amountCents < min) {
    return `Each payment must be at least $${(min / 100).toFixed(2)} (or the full remaining balance).`;
  }
  return null;
}

/** A due date is a calendar day stored at midnight UTC: show that day. */
export const dueLabel = (d) => (d ? moment(formatDate(d)).format("MMMM D, YYYY") : "");
